import { Injectable } from '@angular/core';
import {ApiClientService} from '../../@core/services/api-client.service';
import { TeamMemberModel } from '../models/team-member.model';
import { BaseFucntionsService } from 'src/app/@core/services/base-functions.service';
import { FilterModel } from 'src/app/@core/models/filter.model';
import { ApplicationRoutes } from 'src/app/@core/routes/application-routes.const';

@Injectable({
  providedIn: 'root'
})
export class TeamMembersService extends BaseFucntionsService<TeamMemberModel> {

  constructor(apiClient: ApiClientService) {
    super(ApplicationRoutes.TeamMember.Controller, apiClient)
  }

  getPaging(filterData: FilterModel) {
    return this.apiClient.get(
      `${ApplicationRoutes.TeamMember.Controller}?${this.getQueryString(filterData)}`);
  }
}
